import React from "react";
import { styled } from "@mui/system";
import Typography from "@mui/material/Typography";
import EmojiObjectsIcon from '@mui/icons-material/EmojiObjectsOutlined';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import { setBroadcastFormThunk } from "../../../redux-magic/store";
import StateInterface from "../../../redux-magic/state-interface";

// Container for the whole screen
const Container = styled("div")({
  width: "100vw",
  height: "86px",
  top: "663px",
  backgroundSize: "cover",
  flex: 1
});

// HeaderSection section
const HeaderSection = styled("div")({
  fontWeight: '700',
  fontSize: '20px',
  lineHeight: '160%',
  letterSpacing: '0.15px',
  textAlign: 'center',
  backgroundImage: "url('/images/broadcast/AgentScreenBackground.svg')",
  justifyItems: "center",
  width: "100vw",
  backgroundSize: "cover",
  backgroundRepeat: 'no-repeat',
  height:'17rem',
});

const Header = styled("div")({
  width: '190px',
  height: '59px',
  paddingTop: '25px',
  left: '100px',
  gap: '7px',
  justifyItems:"center",
  display: 'flex', 
  flexDirection: 'column', 
  alignItems: 'center', 
  backgroundSize: "cover",
})

const Title = styled(Typography)({
  fontWeight: '700',
  fontSize: '20px',
  lineHeight: '160%',
  letterSpacing: '0.15px',
  textAlign: 'center',
  color: '#FFFFFF',
});

const SubTitle = styled(Typography)({
  color: "#fff",
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: '143%',
  letterSpacing: '0.15px',
  textAlign: 'center',
  backgroundSize: "cover",
});

const TitleTutorial = styled(Typography)({
  fontWeight: '500',
  fontSize: '10px',
  color: "#FFFFFF",
  lineHeight: '14px',
  textAlign: "center",
   display: "inline-flex", alignItems: "center", gap: 4
});

// Broadcasting info
const BroadcastBox = styled("div")({
  width: "390px",
  height: '141px',
  borderRadius: "16px",
  margin: "3rem auto 3rem auto",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  gap: "8px",
});

const BroadcastLabel = styled("div")({
  lineHeight: '157%',
  fontWeight: '700',
  fontSize: '14px',
  letterSpacing: '0.1px',
  textAlign: "center",
});

const BroadcastNumber = styled(Typography)({
    color: "#FCB24F",
    fontWeight: 700,
    WebkitTextStroke: "2px #000",
    textShadow: `
        -1px -1px 0 #000,  
        1px -1px 0 #000,
        -1px  1px 0 #000,
        1px  1px 0 #000
    `,
    lineHeight: "112.03px",
    letterSpacing: "-1.5px",
    textSlign: "center",
});

// Description
const Description = styled("div")({
  borderRadius: "16px",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  gap: "8px", // Added gap between children
  display: "flex",
  padding: "16px",
});

const DescriptionLabel = styled(Typography)({
  fontWeight: '400',
  fontSize: '12px',
  lineHeight: '166%',
  letterSpacing: '0.4px',
});

const Bulb = styled(EmojiObjectsIcon)({
  color: "#FFB800",
  width: '20px',
  height: '20px',
});

export default function NoOfAgentScreen({dispatch, broadcast}: {
  dispatch: Function;
  broadcast:  StateInterface["broadcast_data"] | undefined | null;
}) {

  React.useEffect(() => {
    const url = `${process.env.PRODUCTION_API_URL}business-profiles/fetch-no-of-agents`;

    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "text/plain",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          dispatch(setBroadcastFormThunk({commission_offered: broadcast?.commission_offered || 0, no_of_agents: data.payload || 0, notes: broadcast?.notes || ""}))
        } else {
          console.error("Error fetching business data:", data.message);
        }
      })
      .catch((err) => {
        console.error("Fetch error:", err);
      });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container>
      <HeaderSection>
        <Header>
          <Title variant="h6">Beegru Broadcast</Title>
          <SubTitle>Try it free for 90 days</SubTitle>
          {/* <TitleTutorial>
              <PlayCircleOutlineIcon />
              View tutorial
          </TitleTutorial> */}
        </Header>
      </HeaderSection>
      <BroadcastBox>
        <BroadcastLabel>Broadcasting it to over</BroadcastLabel>
        <BroadcastNumber variant="h1">{broadcast?.no_of_agents || 0}</BroadcastNumber>
        <BroadcastLabel>Beegru agents</BroadcastLabel>
      </BroadcastBox>
      <Description>
        <Bulb />
        <DescriptionLabel>
          The broadcast feature lets you update {broadcast?.no_of_agents} agents in the Beegru network, boosting your outreach and impact while adapting to your audience&apos;s needs.
        </DescriptionLabel>
      </Description>
    </Container>
  );
}